import { ActionsCreators, connectToJava } from "@tipico/java-react-connector";
import PinPad, { PinPadProps } from "../../components/PinPad/PinPad";

const actionsCreators: ActionsCreators<{
    onNewPin: (newPin: string) => string;
}> = {
    onNewPin: {
        creator: (newPin: string) => newPin,
        name: "PinEntered"
    }
};

export default connectToJava({
    actionsCreators,
    options: { useBehaviorSubjects: false },
    state: {
        EnterPinState: undefined
    },
    stateMapper: ({
        EnterPinState: validationResponse
    }): Pick<
        PinPadProps,
        "needsPreValidation" | "validationResult" | "validationTimestamp"
    > => ({
        needsPreValidation: false,
        validationResult: validationResponse,
        validationTimestamp: Date.now()
    })
})(PinPad);
